import React, {Component} from 'react'
import {Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Grid, Row, Col, Button} from 'react-bootstrap'
import UserDetailsForm from './user-details-form'
import BackLink from '../../../common/back-link/index'
import PageTitle from '../../../common/page-title/index'
import {doPseudoLogin, getUserDetails} from '../../../../actions/users'

import './styles.css'
import Can from "../../../common/guards/can";

class EditUser extends Component {

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {
    this.id = +this.props.match.params.id;
    this.props.dispatch(getUserDetails(this.id))
  }

  componentWillUnmount(){
    this.props.dispatch(actions.reset('deep.admin_user.details'));
    this.props.dispatch({type: 'CLEAR_EDIT_USER'});
  }

  onPseudoLogin = () => {
    this.props.dispatch(doPseudoLogin(this.id))
      .then(() => {
        setTimeout(() => {window.location.href = '/'}, 2000);
      });
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="users">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/users"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="header">
              <PageTitle className="pull-left">Add/Edit user</PageTitle>
                <Can action="pseudo-login-read,pseudo-login-write" subjectClass="web_app">
                  <Button onClick={this.onPseudoLogin}
                          className="red-ghost-btn pseudo-login">Pseudo log in</Button>
                </Can>
            </div>
          </Col>
        </Row>
        {
          this.props.user.relationships && <UserDetailsForm user={this.props.user} edit={!!this.id}/>
        }
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    user: state.users.user,
    fetched: state.users.fetched,
    fetching: state.users.fetching,
  };
};

export default connect(mapStateToProps)(EditUser);



// WEBPACK FOOTER //
// ./src/components/admin/users/edit/details.jsx